import { styled, keyframes } from "@mui/material";
import { shouldNotForwardProps } from "../../../utils/shouldNotForwardProps.js";
const mapSizes = {
  xs: 12,
  sm: 18,
  md: 24,
  lg: 30,
  xl: 36
}, StyledLoaderContainer = styled(
  "div",
  shouldNotForwardProps(["size"])
)(({ size = "md" }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "max-content",
  height: mapSizes[size],
  ...size === "xs" && {
    gap: "3px"
  },
  ...size === "sm" && {
    gap: "6px"
  },
  ...size === "md" && {
    gap: "6px"
  },
  ...size === "lg" && {
    gap: "12px"
  },
  ...size === "xl" && {
    gap: "12px"
  }
})), StyledLoaderItem = styled(
  "div",
  shouldNotForwardProps(["size"])
)(({ size = "md" }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: `${mapSizes[size]}px`,
  maxHeight: `${mapSizes[size]}px`,
  height: `${mapSizes[size]}px`,
  width: `${mapSizes[size]}px`
})), StyledCircle = styled(
  "div",
  shouldNotForwardProps(["size"])
)(({ theme, size = "md" }) => ({
  borderRadius: "50%",
  backgroundColor: theme.palette.secondary[900],
  animation: `${getAnimation({ theme })} 0.6s infinite ease-in-out alternate`,
  width: `${mapSizes[size]}px`,
  height: `${mapSizes[size]}px`,
  "&.circle-1": {
    animationDelay: "0.2s"
  },
  "&.circle-2": {
    animationDelay: "0.4s"
  }
})), getAnimation = ({
  theme
}) => keyframes`
    100% {
        background-color: ${theme.palette.secondary[1e3]};
        scale: .5
    }
`;
export {
  StyledCircle,
  StyledLoaderContainer,
  StyledLoaderItem
};
//# sourceMappingURL=styles.js.map
